import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Document, Page } from "react-pdf";
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';
import '../../../src/styles/Search.css';


var overlay = {
    position: 'fixed',
        top             : 0,
            left            : 0,
                right           : 0,
                    bottom          : 0,
                        zIndex          : 99999999,
                            overflow        : 'hidden',
                                perspective     : 1300,
                                    backgroundColor : 'rgba(0, 0, 0, 0.3)'
}

var content = {
    position: 'relative',
    margin: '1% auto 1% auto',
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .2)',
    background: '#fff',
    overflow: 'auto',
    borderRadius: '4px',
    outline: 'none',
    boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
}


export class MyModal extends Component {
    constructor(props) {
        super(props);        
        this.state = {
            pdfpath: "",
            title: "",
            numPages: null,
            pageNumber: 1
        }
    }


    componentDidMount() {
        this.setState({ pdfpath: this.props.passParam});
        this.setState({ title: this.props.titleparam});
    }

    goToPrevPage = () =>
        this.setState(state => ({ pageNumber: state.pageNumber - 1 }));
    goToNextPage = () =>
        this.setState(state => ({ pageNumber: state.pageNumber + 1 }));

    render() {

        const { text, onRequestClose } = this.props;

        const ScaleUp = {
            transition: { // transition for the modal window
                property: 'all',
                duration: 300, // millisecond
                timingfunction: 'linear'
            },
            begin: { //beginning style of transition
                'transform': 'scale(0.7)',
                'opacity': 0
            },
            end: { // end style of transition
                'transform': 'scale(1)',
                'opacity': 1
            }
        }
        /*
        return (
            <Modal show={this.state.showModal} onHide={this.close}>
                <Modal.Header closeButton>
                    <Modal.Title> {this.state.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div><img ref="bigPic" src={this.state.pdfpath} /></div>
                </Modal.Body>
                <Modal.Footer>
                    <p ref="bigPicInfo"></p>
                </Modal.Footer>
            </Modal>
        )
        
    } */
        
        return (
            <Modal 
                onRequestClose={onRequestClose}
                effect={Effect.ScaleUp}>
                <div style={content}>
                    <div className="Popupcolor Searchmodalheader">{this.state.title}</div>
                    <nav>
                        <button onClick={this.goToPrevPage}>Prev</button>
                        <button onClick={this.goToNextPage}>Next</button>
                        <button onClick={ModalManager.close}>Close Modal</button>
                    </nav>
                    <div className="searchmodalbody">
                    <Document
                        file={this.state.pdfpath}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                    >
                        <Page pageNumber={this.state.pageNumber} />
                        </Document>
                        </div>
                    <p className="searchmodalfooter">Page {this.state.pageNumber} of {this.state.numPages}</p>
                    </div>               
                
            </Modal>
        );
    }
    
}

export default MyModal;



// WEBPACK FOOTER //
// ./src/components/Home/MyModal.jsx